import { SejamEndpoint } from './endpoints'
import { SejamSendOtp, SejamVerifyOtp } from './types'
import { client } from '@/api/client'
import { handleError } from '@/utils/errorHandler'

export const sendOTPService = async (): Promise<SejamSendOtp['Response']> => {
  try {
    const res = await client.post(SejamEndpoint.sendOtp)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const verifyOtpService = async (payload: SejamVerifyOtp['Payload']) => {
  try {
    const res = await client.post(SejamEndpoint.verifyOtp, payload)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}
